export function useScroll() {
    // Typage du retour de useAnchorScroll
    const { scrollToTop } = useAnchorScroll({
      toTop: {
        scrollOptions: {
          offsetTop: 0,
        },
      },
    });
  
    return {
      scrollToTop,
    };
  }